// Checks a T-Mobile promo code and shows or hides the gated page content.
const TmobileGate = {
  timeoutMs: 8000,
  // Re-validate a cached code at most this often. Bounds re-validation to
  // roughly one lookup per browsing session instead of one per page, while
  // still catching a code that got redeemed or expired mid-session.
  revalidateAfterMs: 5 * 60 * 1000,

  init: function () {
    this.overlay = document.querySelector('[data-tmobile-gate-overlay]');

    if (!this.overlay) {
      return;
    }

    this.resolveEligibility();
  },

  // Checks session storage, then cart attributes, then the URL code, in that order.
  resolveEligibility: async function () {
    const storedCode = sessionStorage.getItem('tmobileGateCode');
    const validatedAt = Number(sessionStorage.getItem('tmobileGateValidatedAt'));
    const isFresh = Number.isFinite(validatedAt) && Date.now() - validatedAt < this.revalidateAfterMs;

    if (storedCode && isFresh) {
      await this.addCartAttribute(storedCode);
      this.reveal();
      return;
    }

    if (storedCode) {
      await this.validateCode(storedCode);
      return;
    }

    const cartCode = await this.getCartAttributeCode();

    if (cartCode) {
      await this.validateCode(cartCode);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const urlCode = urlParams.get('tm_code');

    if (!urlCode) {
      this.showMessage('no_code');
      return;
    }

    await this.validateCode(urlCode);
  },

  getCartAttributeCode: async function () {
    try {
      const response = await fetch('/cart.js');

      if (!response.ok) {
        return null;
      }

      const cart = await response.json();

      return (cart.attributes && cart.attributes.tmobileCode) || null;
    } catch (error) {
      console.error('TmobileGate: could not read cart attributes', error);
      return null;
    }
  },

  validateCode: async function (code) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
    }, this.timeoutMs);

    try {
      const url = `https://api.selkirk.com/functions/v1/p1/selkirksport/tmobile-codes/${encodeURIComponent(code)}`;
      const response = await fetch(url, { signal: controller.signal });

      if (response.status === 404) {
        this.showMessage('invalid_code');
        return;
      }

      if (!response.ok) {
        this.showMessage('generic_error');
        return;
      }

      const result = await response.json();
      const status = result.data && result.data.status;

      if (status === 'redeemed') {
        this.showMessage('already_redeemed');
        return;
      }

      if (status === 'available') {
        sessionStorage.setItem('tmobileGateCode', code);
        sessionStorage.setItem('tmobileGateValidatedAt', String(Date.now()));
        await this.addCartAttribute(code);
        this.reveal();
        return;
      }

      this.showMessage('generic_error');
    } catch (error) {
      console.error('TmobileGate: code validation failed', error);
      this.showMessage('generic_error');
    } finally {
      clearTimeout(timeoutId);
    }
  },

  addCartAttribute: async function (code) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            tmobileCode: code,
          },
        }),
      });
    } catch (error) {
      console.error('TmobileGate: could not save cart attribute', error);
    }
  },

  showMessage: function (state) {
    const messages = this.overlay.querySelectorAll('[data-tmobile-gate-message]');

    messages.forEach((message) => {
      message.classList.toggle('is-active', message.dataset.tmobileGateMessage === state);
    });
  },

  reveal: function () {
    this.overlay.classList.add('is-hidden');
    document.body.classList.remove('tmobile-gate-locked');

    const gatedContent = document.querySelectorAll('.tmobile-gated-content');

    gatedContent.forEach((content) => {
      content.style.display = '';
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  TmobileGate.init();
});
